export default __webpack_public_path__ + "static/media/icon-ai.49182ff3.svg";